import * as React from "react"

import { Link } from "gatsby"
import Home from "../components/home"
import Seo from "../components/seo"

const VideozposPage = () => (
  <Home>
      <Seo title="DEMO VIDEO ONLINE SHOP APP WEBSITE POS" />
    <h1><strong><a title="DEMO VIDEO ONLINE SHOP APK APP WEBSITE POS" href="/videozpos">VIDEO DEMO</a></strong></h1>
<div className="embed-responsive embed-responsive-16by9">
<iframe title="video demo online shop website integration aplikasi kasir dan APK APP" width="560" height="315" 
src="https://www.youtube.com/embed/kh80c_NSEEM" 
frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
<br/>
<Link to="/zpos" className="button button-outline">Back ZPOS Apps</Link>
  </Home>
)

export default VideozposPage